module.exports = __webpack_public_path__ + "img/T39.5de72d51.jpg";